import { ActiveFilter, Filter } from '@epicuro-next/models/filters';
import { uniqueBy } from '@epicuro-next/utilities';

// As BE response contains values only with existing orders,
// UI fills response values with currently selected and adds them count 0
export function getAvailableFilters(
  selectedFilters: ActiveFilter[],
  responseFilters: Filter[],
) {
  const prevSelectedFilters = selectedFilters ?? [];
  return responseFilters.map(({ id, values }): Filter => {
    const missedValues = (
      prevSelectedFilters.find((sf) => sf.id === id)?.values ?? []
    ).map((name) => ({
      name,
      count: 0,
    }));

    return {
      id,
      values: uniqueBy(
        [...values.filter(({ count }) => count !== 0), ...missedValues],
        'name',
      ),
    };
  });
}
